<div class="container order-confirmation">
  <div class="row order-confirmation-custom-row">
    <div class="order-confirmation-img"></div>
    <!-- <img class="order-confirmation-img" src="../../assets/img/empty-cart.png"/> -->
  </div>
  <div class="row order-confirmation-custom-row order-confirmation-number">
    <h3 class="confirmation-message">{{ "bulkorder.bulkadd" | cxTranslate }}</h3>
  </div>
  <div
    class="row custom-margin-top order-confirmation-custom-row order-confirmation-summary"
  >
    <p class="order-summary custom-margin-bottom">
      {{ "bulkorder.bulkproduct" | cxTranslate }}
    </p>
  </div>
  <div
    class="row order-confirmation-custom-row order-confirmation-download-btn"
  >
    
      <button (click)="goToQuote()" type="button" class="vs-primary-btn custom-primary-btn">
        {{ "bulkorder.viewquotecart" | cxTranslate }}
      </button>
  </div>
</div>
